import React from 'react';

function SectionTitle({ children }: { children: React.ReactNode }) {
    return <p className="section-title">{children}</p>;
}

export default SectionTitle;
